import { LuWrench } from "react-icons/lu";
import { CgCloseO } from "react-icons/cg";
import { TbReportAnalytics } from "react-icons/tb";
import { IoCalendarOutline } from "react-icons/io5";
import { Routes } from "../enums/Routes";

const menuItems = [
  {
    name: "Showroom Management",
    title: "Showroom Management",
    icon: <LuWrench />,
    path: Routes.Showrooms
  },
  {
    name: "Demo Management",
    title: "Demo Management",
    icon: <LuWrench />,
    path: Routes.Demos
  },
  {
    name: "Showroom Block Management",
    title: "Block Management",
    icon: <CgCloseO />,
    path: Routes.Blocks
  },
  {
    name: "Demo Block Management",
    title: "Block Management",
    icon: <CgCloseO />,
    path: Routes.Blocks
  },
  {
    name: "Block Calendar",
    title: "Calendar",
    icon: <IoCalendarOutline />,
    path: Routes.Calendar
  },
  {
    name: "Test Drive Calendar",
    title: "Calendar",
    icon: <IoCalendarOutline />,
    path: Routes.Calendar
  },
  {
    name: "Reports",
    title: "Reports",
    icon: <TbReportAnalytics />,
    path: Routes.Reports
  }
];

export default menuItems;
